<div class="tf-dropdown-container">
  <div class="tf-dropdown-select" [ngStyle]="{'border-bottom': onSelect ? 'none':''}" (click)="toggleDropDown($event)" [ngClass]="disable ? 'tf-disable-drop-down' : ''">
    <span class="tf-dropdown-combo" *ngIf="isOptionSelected || !externalLabel"
          [ngClass]="{ 'tf-dropdown-small-padding': size == 'small',
          'tf-dropdown-medium-padding': size == 'medium' && ((isOptionSelected && externalLabel) || !isOptionSelected),
          'tf-dropdown-large-padding': size == 'large' && ((isOptionSelected && externalLabel) || !isOptionSelected),
          'tf-dropdown-medium-padding-with-floating-label': size == 'medium' && isOptionSelected && !externalLabel,
          'tf-dropdown-large-padding-with-floating-label': size == 'large' && isOptionSelected && !externalLabel }"
          [ngStyle]="{'border-left': isOptionSelected && hasBlueBorder ? '4px solid #0f88ea':'4px solid transparent'}">
        <span class="tf-dropdown-inline-label"
            *ngIf="isOptionSelected && !externalLabel  && size != 'small'"
            [ngStyle]="{'top': size == 'large' ? '0':'-5px'}">{{ inlineLabel }}</span>
        <span class="tf-dropdown-visible-value" >{{visibleVal}}</span>
    </span>
    <span *ngIf="!isOptionSelected && externalLabel" class="tf-default-text-placeholder"
          [ngClass]="{'tf-dropdown-small-padding': size == 'small',
                      'tf-dropdown-medium-padding': size == 'medium',
                      'tf-dropdown-large-padding': size == 'large' }">Select</span>
    <i class="tf-arrow"
       [ngStyle]="{'border-bottom': upArrow ? '5px solid #222':'', 'border-top': upArrow ? '0px': '', 'top': size == 'large' ? '23px': size == 'small' ? '17px' : '18px' }"></i>
  </div><!-- select-holder -->
  <ul *ngIf="onSelect" class="tf-dropdown-options" [style.max-height]="scrollHeight+'px'||'auto'" [style.width]="overlayWidth">
    <div *ngIf="search" class="tf-dropdown-search-box" (click)="filterOptions()">
      <input #searchInput tfFormInput [attr.placeholder]="searchPlaceHolder" (change)="filterOptions()"
             [(ngModel)]="searchInputValue" (blur)="onSearchInputBlur()" [name]="searchPlaceHolder"/>
      <span class="tf-icon-search tf-dropdown-search-icon" (click)="filterOptions()"></span>
    </div>
    <div #optionsBlock
         [ngStyle]="{'overflow':'auto', 'max-height':scrollHeight?(search?scrollHeight-72+'px':scrollHeight+'px'):(search? '203px': '285px')}">
      <div *ngIf="!virtualScroll">
        <div *ngFor="let item of visibleOptions">
          <li *ngIf="item['type'] !== 'separator' && !isArrayOfStrings" [attr.title]="item && item[optionLabelKey]" [ngClass]="getActiveClass(item) + ' ' + getDisabledClass(item)" (click)="getValue($event, item)"><div class="icon-size"></div>{{item && item[optionLabelKey]}}</li>
          <li *ngIf="item['type'] !== 'separator' && isArrayOfStrings"  [attr.title]="item" [ngClass]="getActiveClass(item) + ' ' + getDisabledClass(item)" (click)="getValue($event, item)"><div class="icon-size"></div>{{item}}</li>
          <li *ngIf= "item['type'] === 'separator'" [attr.title]="item" class="tf-dropdown-separator">
            <div *ngIf="item && item['icon']" [innerHTML]="safeSvg(item['icon'])" class="icon-wrapper"></div>
            {{item && item[optionLabelKey]}}
        </li>
        </div>
      </div>
      <virtual-scroller #scroll *ngIf="virtualScroll" [items]="visibleOptions" [childHeight]="13" [parentScroll]="optionsBlock">
        <div *ngFor="let item of scroll.viewPortItems">
          <li *ngIf= "!isArrayOfStrings" [attr.title]="item && item[optionLabelKey]" [ngClass]="{'active': selectedOption && (item[optionLabelKey] == selectedOption[optionLabelKey])}" (click)="getValue($event, item)">{{item && item[optionLabelKey]}}</li>
          <li *ngIf= "isArrayOfStrings"  [attr.title]="item" [ngClass]="{'active': selectedOption && (item == selectedOption)}" (click)="getValue($event, item)">{{item}}</li>
        </div>
      </virtual-scroller>
    </div>
  </ul>
</div>

